import { AbstractControl } from '@angular/forms';

export type CustomValidatorFn = (control: AbstractControl) => IValidatorCustomError | null;

export type CustomErrorList = Array<ICustomError>;

export interface ICustomError {
  showErrorMessageOn: ValidationShowType;
  priority: number;
  message?: string;
  [key: string]: any;
}

export interface IValidatorCustomError {
  [key: string]: ICustomError;
}

export enum ValidationShowType {
  Touched,
  Dirty,
  Instant,
}

export interface IValidatorConfig {
  showErrorMessageOn?: ValidationShowType;
  priority?: number;
  message?: string;
  [key: string]: any;
}
